import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommanForm from "../../components/FormController/Commanform";
import OfflineBookingValidation from "../../yup/OfflineBooking/OfflineBooking";
import Errormessages from "../../components/ErrorMessage/Errormessages";
import {
  UtcDate,
  formatDate,
  getTimeZoneToUtc,
  handleInput,
} from "../../utils/Helper";
import CommanPhoneNumber from "../../components/Ui/PhoneNumber";
import { CategoryAction } from "../../redux/Action/ProfileAction";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { StaffMemberCategoryServiceGetAction } from "../../redux/Action/StaffMemberAction";
import StaffMemberItem from "../Dashboard/Pages/Services/StaffMemberItem";
import { OfflineBookingAction } from "../../redux/Action/DashboardAction";
import Button from "../../components/Ui/Button";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Config } from "../../config/Config";
import StaffMember from "./StaffMember";

const OfflineBooking = () => {
  const intl = useIntl();

  const dispatch = useDispatch<any>();
  const offlineBooking = useSelector(
    (state: any) => state.OfflineBookingCreateState,
  );
  const [category, setCateory] = useState<any[]>([]);
  const [serviceData, setServiceData]: any = useState([]);
  const [selectedServices, setSelectedServices]: any = useState([]);
  const [Service, setService]: any = useState([{ id: "1" }]);

  const category_data = useSelector((state: any) => state.CategoryState);

  const handleAddDiv = () => {
    const newServiceId = String(Service.length + 1);
    setService([...Service, { id: newServiceId }]);
    trigger();
  };
  const validationSchema = OfflineBookingValidation(
    Service.map((service: any) => service.id),
  );
  const {
    register,
    errors,
    handleSubmit,
    setValue,
    trigger,
    watch,
    getValues,
  } = CommanForm({ validationSchema: validationSchema });

  const handleRemoveDiv = (id: any, index: any) => {
    $(`.service_select_${index}`).val("");
    $(`.cat_select_${index}`).val("");
    setValue("category", "");
    setValue(`price_${id}`, "");
    setValue(`category_${id}`, "");
    setValue(`service_${id}`, "");
    setValue(`service${id}`, "");
    setValue(`duration_${id}`, "");
    setService(Service.filter((div: any) => div.id !== id));
  };

  const handlePhoneNumber = (value: any, code: any) => {
    const regex = new RegExp(code?.dialCode);
    const phone = value.replace(regex, "");
    setValue("phone_country_code", "+" + code?.dialCode);
    setValue("phone_number", phone);
    trigger("phone_number");
  };

  useEffect(() => {
    dispatch(CategoryAction({}));
  }, [dispatch]);

  const role_id = Config?.USER_DETAILS?.role_id;

  const handleSelectServices = (e: any, index: any) => {
    const value = e.target.value;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const duration = selectedOption.getAttribute("data-duration");
    const price = selectedOption.getAttribute("data-price");

    setSelectedServices(value);

    setValue(`service_${index?.id}`, value ? value : "");
    setValue(`duration_${index?.id}`, duration ? duration : "");
    setValue(`price_${index?.id}`, price ? price : "");

    trigger(`service_${index?.id}`);
    trigger(`duration_${index?.id}`);
    trigger(`price_${index?.id}`);
  };

  useEffect(() => {
    Service.forEach((item: any) => {
      register(`sl${item.id}`);
      register(`slot_st_${item.id}`);
    });
  }, [register, Service]);

  const [isPreBooking, setIsPreBooking]: any = useState(true);

  const clearServiceTimes = () => {
    Service.forEach((item: any) => {
      setValue(`sl${item.id}`, null);
      setValue(`slot_st_${item.id}`, "");
    });
  };

  const handleToggle = (isPre: boolean) => {
    setIsPreBooking(isPre);
    const current = watch("start_date");
    if (current && moment(current, "YYYY-MM-DD", true).isValid()) {
      const day = moment(current, "YYYY-MM-DD").startOf("day");
      const today = moment().startOf("day");
      // Pre = today/future only; Post = today/past only
      if ((isPre && day.isBefore(today)) || (!isPre && day.isAfter(today))) {
        setValue("start_date", "");
        clearServiceTimes();
      }
    }
  };

  const onSubmit = async (payload: any) => {
    const customerDetails = {
      name: payload.name,
      email: payload.email,
      phone_country_code: payload.phone_country_code,
      phone_number: payload.phone_number,
      booking_date: payload.start_date,
    };

    const services = [];
    for (let i = 1; payload.hasOwnProperty(`service_${i}`); i++) {
      const utcDateTime = moment(payload[`sl${i}`])
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss");

      services.push({
        service_id: Number(payload[`service_${i}`]),
        staff_id: payload[`selectedStaffMembers_${i}`],
        slot_st: utcDateTime,
        duration: Number(payload[`duration_${i}`]),
        amount: Number(payload[`price_${i}`]),
      });
    }

    const finalPayload = {
      ...customerDetails,
      services,
      booking_type: isPreBooking == true ? 1 : 2,
    };

    dispatch(OfflineBookingAction(finalPayload));
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (offlineBooking?.status) {
      navigate("/dashboard");
    }
  }, [offlineBooking]);

  const handleCategory = (e: any, index: any, item: any) => {
    const catId = e.target.value;
    setValue("category", catId);
    trigger("category");
    setValue(`category_${item?.id}`, catId ? catId : ""); // Set form v
    trigger(`category_${item?.id}`);

    setCateory((prevArr) => {
      if (catId) {
        const newArr = [...prevArr];
        newArr[index] = { index, catId: Number(catId) };
        return newArr;
      } else {
        return prevArr.filter((item) => item.index !== index);
      }
    });
    dispatch(StaffMemberCategoryServiceGetAction({ cat_id: catId, index }));
  };

  const service_data = useSelector(
    (state: any) => state.StaffMemberCategoryServiceState,
  );

  useEffect(() => {
    if (service_data?.data) {
      setServiceData((prevServiceData: any) => {
        const newData = [...prevServiceData];
        const index = service_data.data.custom_params.index;
        if (index !== undefined) {
          newData[index] = service_data.data.data;
        }
        return newData;
      });
    }
  }, [service_data]);

  const handleSelectedStaffMember = (id: any, serviceId: any) => {
    setValue(`selectedStaffMembers_${serviceId?.id}`, id ? id : ""); // Set form v
    trigger(`selectedStaffMembers_${serviceId?.id}`);
    setService((prevServices: any) => {
      return prevServices.map((service: any) => {
        if (service.id === serviceId) {
          return { ...service, selectedStaffMembers: id };
        }
        return service;
      });
    });
  };

  const handleTime = (date: any, item: any) => {
    const slotStr = date
      ? moment(date).format("YYYY-MM-DDTHH:mm:ss")
      : "";
    setValue(`slot_st_${item.id}`, slotStr, { shouldValidate: true });
    setValue(`sl${item.id}`, date);
    trigger(`slot_st_${item.id}`);
  };

  useEffect(() => {
    return () => {
      dispatch(CategoryAction("RESET"));
      dispatch(OfflineBookingAction("RESET"));
      dispatch(StaffMemberCategoryServiceGetAction("RESET"));
    };
  }, []);

  const resolveBookingDay = (bookingDateStr?: string) => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (
      bookingDateStr &&
      moment(bookingDateStr, "YYYY-MM-DD", true).isValid()
    ) {
      const d = moment(bookingDateStr, "YYYY-MM-DD").toDate();
      return {
        bookingDay: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
        today,
      };
    }
    return { bookingDay: today, today };
  };

  const getMinTime = (bookingDateStr?: string) => {
    const { bookingDay, today } = resolveBookingDay(bookingDateStr);
    const isBookingToday = bookingDay.getTime() === today.getTime();

    // Other days: full day from 00:00 (keeps minTime <= maxTime)
    if (!isBookingToday) {
      const min = new Date(bookingDay);
      min.setHours(0, 0, 0, 0);
      return min;
    }

    // Today + pre: no past times; today + post: from start of day
    if (isPreBooking) {
      const min = new Date();
      min.setSeconds(0, 0);
      return min;
    }

    const min = new Date(bookingDay);
    min.setHours(0, 0, 0, 0);
    return min;
  };

  const getMaxTime = (bookingDateStr?: string) => {
    const { bookingDay, today } = resolveBookingDay(bookingDateStr);
    const isBookingToday = bookingDay.getTime() === today.getTime();

    // Today + post: up to now; otherwise end of the selected booking day
    if (isBookingToday && !isPreBooking) {
      const max = new Date();
      max.setSeconds(59, 0);
      return max;
    }

    const max = new Date(bookingDay);
    max.setHours(23, 59, 59, 0);
    return max;
  };

  return (
    <div className="col-lg-9 addNewService ">
      <div className="dashboard bg-white">
        <div className="dashboardTop d-sm-flex justify-content-between align-items-center">
          <h2 className="mb-0">
            <button type="button" className="btn mobileMenu p-1 d-lg-none">
              <span className="icon-menu-right"></span>
            </button>{" "}
            <FormattedMessage id="add_offline_bookings" />
          </h2>
          <div className="btn-group" role="group" aria-label="primaryTabs">
            <button
              type="button"
              className={`btn ${isPreBooking ? "btn-dark" : "btn-outline-dark"}`}
              onClick={() => handleToggle(true)}
            >
              {" "}
              <FormattedMessage id="pre_bookings" />{" "}
            </button>
            <button
              type="button"
              className={`btn ${!isPreBooking ? "btn-dark" : "btn-outline-dark"}`}
              onClick={() => handleToggle(false)}
            >
              <FormattedMessage id="post_bookings" />
            </button>
          </div>
        </div>
        <div className="dashboarcard">
          <div className="text-end">
            <button
              type="button"
              className="btn btn p-0"
              onClick={handleAddDiv}
            >
              <span className="icon-plus-full  f-30"></span>{" "}
            </button>
          </div>
          <div className="row">
            <div className="col-md-10">
              <form onSubmit={handleSubmit(onSubmit)}>
                {Service.map((item: any, index: any) => {
                  const selectedDate = watch(`sl${item.id}`);
                  const bookingStartDate = watch("start_date");

                  return (
                    <>
                      <div key={item?.id} className="serviceRow mb-4">
                        <div className="row gx-2 gy-4">
                          <div className="col">
                            <div className="row gy-4">
                              {index == 0 && (
                                <>
                                  <div className="col-md-4 normalINput">
                                    <label className="form-label">
                                      <FormattedMessage id="customer_name" />
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      // placeholder="Enter customer name"
                                      placeholder={intl.formatMessage({
                                        id: "enter_customer_name",
                                      })}
                                      {...register("name")}
                                    />
                                    {/* <Errormessages errors={errors} name="name" /> */}
                                    <Errormessages
                                      errors={errors}
                                      name={`name`}
                                    />
                                  </div>
                                  <div className="col-md-4 normalINput">
                                    <label className="form-label">
                                      <FormattedMessage id="customer_email" />
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      placeholder={intl.formatMessage({
                                        id: "enter_email_address",
                                      })}
                                      {...register("email")}
                                    />
                                    <Errormessages
                                      errors={errors}
                                      name={`email`}
                                    />
                                  </div>
                                  <div className="col-md-4 normalINput">
                                    <label className="form-label">
                                      <FormattedMessage id="customer_mobile_number" />
                                    </label>
                                    <div className="ReactnormalINput input-with-num">
                                      <CommanPhoneNumber
                                        handleMobileNumber={handlePhoneNumber}
                                        value={`${watch("phone_country_code")}${watch("phone_number")}`}
                                      />
                                    </div>
                                    <Errormessages
                                      errors={errors}
                                      name="phone_number"
                                    />
                                  </div>

                                  <div className="col-md-4 normalINput">
                                    <label className="form-label">
                                      <FormattedMessage id="service_date" />
                                    </label>
                                    <DatePicker
                                      className="form-control"
                                      placeholderText="MM/DD/YYYY"
                                      timeFormat="MM DD YYYY"
                                      onKeyDown={(e: any) => e.preventDefault()}
                                      showYearDropdown
                                      scrollableYearDropdown
                                      yearDropdownItemNumber={50}
                                      selected={
                                        watch("start_date")
                                          ? moment(
                                              watch("start_date"),
                                              "YYYY-MM-DD",
                                            ).toDate()
                                          : null
                                      }
                                      showIcon
                                      minDate={isPreBooking ? new Date() : undefined}
                                      maxDate={isPreBooking ? undefined : new Date()}
                                      onChange={(start_date: any) => {
                                        setValue(
                                          `start_date`,
                                          start_date
                                            ? moment(start_date).format(
                                                "YYYY-MM-DD",
                                              )
                                            : "",
                                        );
                                        clearServiceTimes();
                                        trigger("start_date");
                                      }}
                                    />
                                    <Errormessages
                                      errors={errors}
                                      name="start_date"
                                    />
                                  </div>
                                </>
                              )}

                              {role_id == 1 ? (
                                <div className="col-md-4 normalINput">
                                  <label className="form-label">
                                    <FormattedMessage id="service_category" />
                                  </label>
                                  <select
                                    className={`form-select cat_select_${index}`}
                                    onChange={(e) =>
                                      handleCategory(e, index, item)
                                    }
                                  >
                                    <option value="">
                                      {
                                        <FormattedMessage id="select_category" />
                                      }
                                    </option>
                                    {category_data?.data?.data?.categories?.map(
                                      (catItem: any) => {
                                        return (
                                          <>
                                            <option
                                              key={catItem?.category_detail?.id}
                                              value={
                                                catItem?.category_detail?.id
                                              }
                                            >
                                              {catItem?.category_detail?.name}
                                            </option>
                                          </>
                                        );
                                      },
                                    )}
                                  </select>
                                  <Errormessages
                                    errors={errors}
                                    name={`category_${item.id}`}
                                  />
                                </div>
                              ) : (
                                <div className="col-md-4 normalINput">
                                  <label className="form-label">
                                    <FormattedMessage id="service_category" />
                                  </label>
                                  <select
                                    className={`form-select cat_select_${index}`}
                                    onChange={(e) =>
                                      handleCategory(e, index, item)
                                    }
                                  >
                                    <option value="">
                                      {
                                        <FormattedMessage id="select_category" />
                                      }
                                    </option>
                                    {category_data?.data?.data?.category_detail?.map(
                                      (catItem: any) => {
                                        return (
                                          <>
                                            <option
                                              key={
                                                catItem?.category_details?.[0]
                                                  ?.id
                                              }
                                              value={
                                                catItem?.category_details?.[0]
                                                  ?.id
                                              }
                                            >
                                              {
                                                catItem?.category_details?.[0]
                                                  ?.name
                                              }
                                            </option>
                                          </>
                                        );
                                      },
                                    )}
                                  </select>
                                  <Errormessages
                                    errors={errors}
                                    name={`category_${item.id}`}
                                  />
                                </div>
                              )}

                              <div className="col-md-4 normalINput">
                                <label className="form-label">
                                  <FormattedMessage id="service_name" />
                                </label>
                                <select
                                  className={`form-select service_select_${index}`}
                                  onChange={(e) =>
                                    handleSelectServices(e, item)
                                  }
                                >
                                  {/* <select className={`form-select service_select_${index}`} {...register(`service${index}`)} onChange={(e) => handleSelectServices(e, item)} > */}
                                  <option value="">
                                    {<FormattedMessage id="select_service" />}
                                  </option>
                                  {serviceData[index]?.length > 0 &&
                                    serviceData[index]?.map(
                                      (serviceItem: any) => {
                                        return (
                                          <option
                                            key={serviceItem?.id}
                                            // value={`service${index}`}
                                            value={serviceItem?.id}
                                            data-duration={
                                              serviceItem?.duration
                                            }
                                            data-price={serviceItem?.price}
                                            selected={
                                              selectedServices[index] ==
                                              serviceItem?.id
                                            }
                                          >
                                            {" "}
                                            {serviceItem?.name}
                                          </option>
                                        );
                                      },
                                    )}
                                </select>
                                <Errormessages
                                  errors={errors}
                                  name={`service_${item.id}`}
                                />
                              </div>

                              <div className="col-md-4 normalINput">
                                <label className="form-label">
                                  <FormattedMessage id="service_duration" />
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="00 : 00 Hours"
                                  {...register(`duration_${item.id}`)}
                                  value={watch(`duration_${item.id}`)}
                                  readOnly
                                />
                                <Errormessages
                                  errors={errors}
                                  name={`duration_${item.id}`}
                                />
                              </div>

                              <div className="col-md-4 normalINput timeSelect">
                                <label className="form-label">
                                  <FormattedMessage id="service_time" />
                                </label>
                                <DatePicker
                                  className="form-control"
                                  selected={selectedDate}
                                  onChange={(date) => handleTime(date, item)}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={5}
                                  timeCaption="Time"
                                  dateFormat="HH:mm"
                                  timeFormat="HH:mm"
                                  placeholderText="00:00"
                                  minTime={getMinTime(bookingStartDate)}
                                  maxTime={getMaxTime(bookingStartDate)}
                                />
                                <Errormessages
                                  errors={errors}
                                  name={`slot_st_${item.id}`}
                                />
                              </div>

                              <div className="col-md-4 normalINput normalINputIcon">
                                <label className="form-label">
                                  <FormattedMessage id="price" />
                                </label>
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="00.00"
                                    onInput={handleInput}
                                    {...register(`price_${item.id}`)}
                                    value={watch(`price_${item.id}`)}
                                    readOnly
                                  />
                                  <span className="priceSIgn">€</span>
                                </div>
                                <Errormessages
                                  errors={errors}
                                  name={`price_${item.id}`}
                                />
                              </div>
                            </div>
                          </div>

                          {Service?.length > 1 && index > 0 && (
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn closeBTN p-0"
                                onClick={() => handleRemoveDiv(item?.id, index)}
                              >
                                <span className="icon-close"></span>
                              </button>
                            </div>
                          )}
                        </div>

                        <div className="category staffRow mt-3">
                          <h6>
                            <FormattedMessage id="select_staff_member" />
                          </h6>
                          <ul>
                            <StaffMember
                              handleSelectedStaffMember={
                                handleSelectedStaffMember
                              }
                              data={item}
                              watch={watch}
                              dataIndex={index}
                            />
                          </ul>
                          <Errormessages
                            errors={errors}
                            name={`selectedStaffMembers_${item.id}`}
                          />
                        </div>
                        {/* <div className='category staffRow mt-3'>
                                                    <h6>Select Staff Member</h6>
                                                    <ul>
                                                        <StaffMember handleSelectedStaffMember={handleSelectedStaffMember} data={item} watch={watch} />
                                                    </ul>
                                                    <Errormessages errors={errors} name={`selectedStaffMembers_${item.id}`} />
                                                </div> */}
                      </div>
                    </>
                  );
                })}
                <Button
                  text={intl.formatMessage({ id: "submit" })}
                  type="submit"
                  className="btn btn-fill"
                  isLoading={offlineBooking?.loading}
                />
                {/* <button type='submit' className='btn btn-fill'>Submit</button> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineBooking;
